<template>
    <div class="alternate-form-component-container">
        <div class="alternate-form-component-container__icon-container">
            <svg width="23" height="23">
                <path
                    d="M17.015 0c.513 0 .999.203 1.362.566l2.972 2.97a3.327 3.327 0 01.928 2.883c-.614 3.698-2.578 7.364-5.536 10.328-2.96 2.957-6.626 4.923-10.32 5.532a3.11 3.11 0 01-.536.045c-.876 0-1.73-.355-2.35-.974L.568 18.381a1.922 1.922 0 010-2.728l3.203-3.195a1.896 1.896 0 011.362-.567c.513 0 .998.204 1.36.567l2.5 2.502a11.331 11.331 0 003.55-2.416 11.3 11.3 0 002.41-3.552l-2.5-2.503a1.924 1.924 0 010-2.728l3.2-3.195A1.91 1.91 0 0117.016 0zm-.003 1.284a.754.754 0 00-.531.22L13.39 4.597a.75.75 0 000 1.06l3.03 3.028-.056.152a12.773 12.773 0 01-2.934 4.594 12.776 12.776 0 01-4.592 2.937l-.153.056-3.028-3.033a.751.751 0 00-1.061 0l-3.092 3.095a.749.749 0 000 1.06l2.916 2.915c.39.387.92.607 1.457.607.112 0 .224-.01.336-.028 3.439-.569 6.862-2.412 9.639-5.188 2.775-2.775 4.618-6.2 5.187-9.643a2.057 2.057 0 00-.581-1.79l-2.915-2.917a.754.754 0 00-.531-.219z"
                    fill="#1B3C70"
                    fill-rule="evenodd"
                />
            </svg>
        </div>
        <div class="alternate-form-component-container__input-group">
            <ValidationProvider
                v-slot="{ errors }"
                :rules="
                    isRequired
                        ? 'phone-required|phone-numeric|phone-min:10|phone-max:12'
                        : 'phone-numeric|phone-min:10|phone-max:12'
                "
                mode="lazy"
                tag="section"
                name="telefoonnummer"
            >
                <AlternateFormComponent
                    v-model.trim="phone"
                    name="telefoon"
                    type="tel"
                    :label="label"
                    :placeholder="label"
                    :required="isRequired"
                    :hint="errors[0]"
                    :state="errors[0] ? 'error' : null"
                />
            </ValidationProvider>
        </div>
    </div>
</template>

<script>
import AlternateFormComponent from './AlternateFormComponent';
import { ValidationProvider, extend } from 'vee-validate';
import { required, min, max, numeric } from 'vee-validate/dist/rules';

extend('phone-required', {
    ...required,
    message: 'Telefoonnummer is een verplicht veld',
});

extend('phone-max', {
    ...max,
    message: 'Voer het telefoonnummer correct in',
});

extend('phone-min', {
    ...min,
    message: 'Voer het telefoonnummer correct in',
});

extend('phone-numeric', {
    ...numeric,
    message: 'Voer het telefoonnummer correct in',
});

export default {
    name: 'KWFFormPhone',
    components: { ValidationProvider, AlternateFormComponent },
    props: {
        value: String,
        label: {
            type: String,
            default: 'Telefoon',
        },
        isRequired: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            phone: this.value ?? '',
        };
    },
    watch: {
        phone: {
            handler(newVal) {
                if (newVal) {
                    this.$emit('input', newVal);
                }
            },
        },
    },
};
</script>
